import { render } from "./DashboardView.vue?vue&type=template&id=7230a0c8&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=7230a0c8&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7230a0c8"]])

export default __exports__